import { render, staticRenderFns } from "./sellingView.vue?vue&type=template&id=636b3934&"
import script from "./sellingView.vue?vue&type=script&lang=js&"
export * from "./sellingView.vue?vue&type=script&lang=js&"
import style0 from "./sellingView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports